var _path, _path2, _path3, _rect, _path4, _path5, _rect2, _path6, _path7, _rect3, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyBox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 136,
    viewBox: "0 0 201 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.398 97.298C200.398 94.982 198.521 93.1045 196.205 93.1045H12.7791C10.463 93.1045 8.58552 94.982 8.58552 97.298C8.58552 99.6141 10.463 101.492 12.7791 101.492H37.3658C39.6818 101.492 41.5593 103.369 41.5593 105.685C41.5593 108.001 39.6818 109.879 37.3658 109.879H32.4477C30.1316 109.879 28.2541 111.756 28.2541 114.072C28.2541 116.388 30.1316 118.266 32.4477 118.266H47.0432C49.3592 118.266 51.2368 120.143 51.2368 122.459C51.2368 124.775 49.3592 126.653 47.0432 126.653H40.5122C38.1961 126.653 36.3186 128.53 36.3186 130.846C36.3186 133.162 38.1961 135.04 40.5122 135.04H140.405C142.721 135.04 144.599 133.162 144.599 130.846C144.599 128.53 142.721 126.653 140.405 126.653H118.302C115.986 126.653 114.108 124.775 114.108 122.459C114.108 120.143 115.986 118.266 118.302 118.266H183.145C185.461 118.266 187.338 116.388 187.338 114.072C187.338 111.756 185.461 109.879 183.145 109.879H161.45C159.134 109.879 157.257 108.001 157.257 105.685C157.257 103.369 159.134 101.492 161.45 101.492H196.205C198.521 101.492 200.398 99.6141 200.398 97.298ZM64.6861 126.653C62.3701 126.653 60.4926 124.775 60.4926 122.459C60.4926 120.143 62.3701 118.266 64.6861 118.266H78.463C80.779 118.266 82.6565 120.143 82.6565 122.459C82.6565 124.775 80.779 126.653 78.463 126.653H64.6861Z",
    fill: "#F1FAFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M149.805 130.846C149.805 128.53 151.683 126.653 153.999 126.653H173.958C176.274 126.653 178.151 128.53 178.151 130.846C178.151 133.162 176.274 135.04 173.958 135.04H153.999C151.683 135.04 149.805 133.162 149.805 130.846Z",
    fill: "#F1FAFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9101 114.072C18.9101 111.756 17.0325 109.879 14.7165 109.879H4.59199C2.27595 109.879 0.398438 111.756 0.398438 114.072C0.398438 116.388 2.27595 118.266 4.59199 118.266H14.7165C17.0325 118.266 18.9101 116.388 18.9101 114.072Z",
    fill: "#F1FAFF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 49.3281,
    y: 46.9502,
    width: 50.4567,
    height: 55.5023,
    fill: "#93CBF0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3287 46.9502H99.7854L85.9098 31.8132H35.4531L49.3287 46.9502Z",
    fill: "#0071BC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3296 46.9502V65.2407H31.0391L49.3296 46.9502Z",
    fill: "#0071BC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 99.7891,
    y: 46.9502,
    width: 58.0252,
    height: 55.5023,
    fill: "#0071BC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7891 46.9502H157.814L170.428 70.9171H112.403L99.7891 46.9502Z",
    fill: "#93CBF0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7891 46.9502H157.814L170.428 35.5974H112.403L99.7891 46.9502Z",
    fill: "#8BBFE2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 56.8438,
    y: 57.6201,
    width: 25.8065,
    height: 6.45161,
    fill: "#0071BC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1094 9.42871L49.5622 19.2727",
    stroke: "#0071BC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M59.75 1.16895L62.3076 13.6667",
    stroke: "#0071BC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M162.562 9.42871L152.11 19.2727",
    stroke: "#0071BC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M141.922 1.16895L139.364 13.6667",
    stroke: "#0071BC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyBox);
export default __webpack_public_path__ + "static/media/emptyBox.43016ca7f82f7a174c2f20fcf59fafbd.svg";
export { ForwardRef as ReactComponent };